export default __webpack_public_path__ + "static/wsl-meshery-login-14a858cd81f905f4468e60527211381f.webp";